import React from 'react';
import { Campaign } from '~/api/models/campaign';
import SelectOTA from "~/features/base/components/forms/ota/SelectOTA";
import { ALL } from '~/features/base/constants/filterOptions';

interface StageSelectProps {
  campaign?: Campaign;
  selectedStage: string;
  onStageChange: (stageId: string) => void;
}

const StageSelect: React.FC<StageSelectProps> = ({ campaign, selectedStage, onStageChange }) => {
  const stageOptions = [
    { value: ALL, label: 'All Stages', id: ALL },
    ...(campaign?.stages?.filter(stage => stage.id).map((stage, index) => ({
      value: stage.id!.toString(),
      label: `Stage ${stage.stageOrder ?? index + 1}`,
      id: stage.id!.toString()
    })) || [])
  ];

  const handleStageChange = (value: any) => {
    onStageChange(value.id);
  };

  return (
    <SelectOTA
      value={[selectedStage]}
      onChange={handleStageChange}
      options={stageOptions}
      className='shadow-none'
      btnClassName='btn height-auto focus-shadow-none hover-bg-none tag tag-small'
    />
  );
};

export default StageSelect;